<template>
  <job-alert-list :filters="filters"/>
</template>
<script>
  import JobAlertList from 'src/views/admin/job-alerts/JobAlertList'

  export default {
    components: {
      JobAlertList
    },
    computed: {
      candidate () {
        return this.$store.state.candidate.currentCandidate || {}
      },
      filters() {
        return [
          {
            key: 'with',
            value: 'candidate'
          },
          {
            key: 'match[candidate_uuid]',
            value: this.candidate.uuid
          },
          {
            key: 'sort',
            value: '+created_at'
          }
        ]
      }
    }
  }
</script>
<style>
</style>
